/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 24/03/2025
*/

import React from 'react'
import {Typography } from '@mui/material';
import Styles from './productsIntro.module.css';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import ProductBackGround from '../../assets/images/product/productCover-BlackBox3.png';

const POS = () => {

  return (


    <>
      <div className={Styles.topContentMainContainerPos}>
        <img src={ProductBackGround} className={Styles.productCoverBlackBox} />
        <div className={Styles.topContentBox}>
          <Typography variant='h2' className={Styles.productTopHeader} >Point Of Sale</Typography>
          <Typography variant='h6' className={Styles.productTopBody}>N-ACH state-of-the-art Online Point of Sale (POS)
            System—an intelligent, reliable, and efficient solution designed to revolutionize the way you manage your business transactions.
            N-ACH state-of-the-art Online Point of Sale (POS) System—an intelligent, reliable, and efficient solution
            designed to revolutionize the way you manage your business transactions.</Typography>
        </div>
      </div>

      <div className={Styles.outerContainer}>
        <Typography variant='h5' className={Styles.titelFirsttxt} >KEY FEATURES</Typography>

        <div className={Styles.descriptionContainer}>
          <div>
            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Seamless Transactions</Typography>
                <Typography className={Styles.descriptionText}>
                  Process sales swiftly and efficiently with our intuitive POS interface. From ringing up products to accepting various payment methods, our system ensures smooth and seamless transactions.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Real-Time Inventory Management</Typography>
                <Typography className={Styles.descriptionText}>
                  Stay on top of your stock levels in real-time. Our POS system is integrated with an advanced inventory management feature, helping you optimize stock, reduce overstocking, and streamline orders.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Customizable for Your Business</Typography>
                <Typography className={Styles.descriptionText}>
                  Tailor the system to suit your unique business needs. Customize products, prices, and tax settings to align with your specific industry and operational requirements.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Cloud-Based Accessibility</Typography>
                <Typography className={Styles.descriptionText}>
                  Access your POS system from anywhere, anytime. Our cloud-based solution ensures that you can manage your business on-the-go, whether you're at the store, at home, or on vacation.
                </Typography>
              </div>
            </div>
          </div>

          <div>
            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Insightful Reporting and Analytics</Typography>
                <Typography className={Styles.descriptionText}>
                  Gain valuable insights into your sales, customer behavior, and product performance through comprehensive reporting tools. Make informed decisions to grow your business strategically.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Security and Compliance</Typography>
                <Typography className={Styles.descriptionText}>
                  Your data's security is our top priority. Our system adheres to industry-leading security standards, providing a secure and compliant environment for all your transactions.
                </Typography>
              </div>
            </div>

            <div className={Styles.descriptionItem}>
              <AutoStoriesIcon className={Styles.bullet} />
              <div>
                <Typography className={Styles.descriptionTopic}>Customer Relationship Management (CRM)</Typography>
                <Typography className={Styles.descriptionText}>
                  Build stronger customer relationships by capturing customer data and preferences. Use this information to provide personalized services and drive repeat business.
                </Typography>
              </div>
            </div>
          </div>


        </div>

      </div>
    </>


  );
}

export default POS;